import { globalAxios } from "@/axios-path.js";

export default {
    namespaced: true,
    state: {
        baseDistanceList: []
    },
    mutations: {
        setBaseDistanceList(state, data) {
            state.baseDistanceList = data.sort((a, b) => b.distance_id - a.distance_id)
        },
    },
    actions: {
        async createBaseDistanceOld({ commit, dispatch, rootState }, form) {
            for (let val of form.distance_text) {
                val.transport_charge_start = parseFloat(val.transport_charge_start)
                val.transport_charge_end = parseFloat(val.transport_charge_end)
                val.transport_charge_price = parseFloat(val.transport_charge_price)
            }

            let url = `/create/distanceBase`
            let res = await dispatch(
                "fetchGeneral/axiosPathPostData",
                { url, form },
                { root: true }
            );
            if (typeof res == "boolean" && res == false) {
                return false;
            } else {
                if (res.msg == true) {
                    commit("setBaseDistanceList", res.data);
                    return true;
                } else {
                    return false
                }
            }
        },
        async getBaseDistanceList({ commit, dispatch, rootState }) {
            let url = `/list/distanceBases`
            let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
                root: true
            });
            if (typeof res == "boolean" && res == false) {
                return [];
            } else {
                if (res.msg == true) {
                    commit('setBaseDistanceList', res.data)
                    return res;
                } else {
                    return [];
                }
            }
        },
        async fetchBaseDistance({ }, { distance_type, province }) {
            let url = `/api/v1/service/${province}/${distance_type}/list/distanceBases`
            return globalAxios.get(url).then((res) => {
                if (res.msg === false) return false;
                return res.data;
            }).catch((error) => false);
        },
        async updateBaseDistance({ }, { distance_type, province, distance_id, payload }) {
            for (let val of payload.distance_text) {
                val.transport_charge_end = parseFloat(val.transport_charge_end);
                val.transport_charge_price = parseFloat(val.transport_charge_price);
                val.transport_charge_start = parseFloat(val.transport_charge_start);
            }

            if (payload.distance_district == null) {
                payload.distance_district = [];
            }

            if (payload.distance_store == null) {
                payload.distance_store = [];
            }
            let url = `/api/v1/service/${province}/${distance_type}/edit/distanceBase/${distance_id}`
            return globalAxios.put(url, payload).then((res) => {
                if (res.msg === false) return false;
                return res.data;
            }).catch((error) => false);
        },
        async createBaseDistance({ }, { distance_type, province, payload }) {
            for (let val of payload.distance_text) {
                val.transport_charge_end = parseFloat(val.transport_charge_end);
                val.transport_charge_price = parseFloat(val.transport_charge_price);
                val.transport_charge_start = parseFloat(val.transport_charge_start);
            }

            if (payload.distance_district == null) {
                payload.distance_district = [];
            }

            if (payload.distance_store == null) {
                payload.distance_store = [];
            }

            let url = `/api/v1/service/${province}/${distance_type}/create/distanceBase`
            return globalAxios.post(url, payload).then((res) => {
                if (res.msg === false) return false;
                return res.data;
            }).catch((error) => false);
        }
    }
};